module.exports = new __parcel__URL__("service-requestsDark.ce6d6e11.svg").toString();